module.exports = __webpack_public_path__ + "static/media/4ODA13.242f8ed9.jpg";